// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SortUpSvg from '@rsuite/icon-font/lib/direction/SortUp';
var SortUp = createSvgIcon({
    as: SortUpSvg,
    ariaLabel: 'sort up',
    category: 'direction',
    displayName: 'SortUp'
});
export default SortUp;
